import { put, call, delay } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/modal';
import { postFile } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';
import { addProgressBar, clearProgressBar, startProgressBar, stopProgressBar } from '../actions/settings/loading';

export function* modalSKCreate({ payload }) {
  try {
    const data = window.btoa(unescape(encodeURIComponent(JSON.stringify({
      restMethod: 'postFile',
      url: '/reports/qua_cert',
      args: {
        plantId: payload.plantId,
        qcId: payload.qcId,
        qcNumId: payload.qcNumId,
        qcShop: payload.qcShop,
        qcDate: payload.qcDate,
        printQcFromStorage: payload.printQcFromStorage
      }
    }))));
    const newWindow = window.open(`/pdf-viewer/${data}`, '_blank');
    newWindow.opener = null;
    yield put(action.modalSKCreateSuccess());
  } catch (error) {
    console.debug('ERROR modalSKCreate', error);
    yield put(action.modalSKCreateFail());
  }
}

export function* modalSKZipCreate({ payload }) {
  try {
    if (payload[0].plantId === '8107'
    || payload[0].plantId === '8153'
    || payload[0].plantId === '10014'
    || payload[0].plantId === '8155') {
      yield put(startProgressBar(payload.length));
      const report = [];
      let errorQC = '';
      let techInfo = '';
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < payload.length; i++) {
        try {
          report[i] = yield call(
            postFile,
            '/reports/qua_cert',
            {
              plantId: payload[i].plantId,
              qcId: payload[i].qcId,
              qcNumId: payload[i].qcNumId,
              qcShop: payload[i].qcShop,
              qcDate: payload[i].qcDate,
              printQcFromStorage: payload[i].printQcFromStorage
            }
          );
        } catch (error) {
          errorQC += `${payload[i].qcId}, `;
          techInfo = error.message;
        } finally {
          yield put(addProgressBar());
        }
      }
      yield put(stopProgressBar());
      yield put(clearProgressBar());
      if (report.length > 0) {
      // eslint-disable-next-line no-plusplus
        for (let i = 0; i < report.length; i++) {
          yield delay(500);
          const file = new Blob([report[i].data], { type: 'application/octet-stream' });
          saveAs(file, report[i].headers['content-disposition'].replace('attachment; filename=', ''));
        }
        // const file = new Blob([report.data], { type: 'application/octet-stream' });
        // yield call(saveAs, file, 'multiple_qc.zip');
        yield put(action.modalSKZipCreateSuccess());
      }
      if (errorQC.length > 0) {
        errorQC.substring(0, errorQC.length - 2);
        yield put(
          modalErrorOpen({
            message: `${formatMessage('textError').errorLoadQC}: ${errorQC} ${formatMessage('textError').contactSupport}`,
            techInfo,
            types: 'info',
            title: formatMessage('textError').warning
          })
        );
        yield put(action.modalSKZipCreateFail());
      }
    } else {
      const report = yield call(
        postFile,
        '/reports/qua_cert/multiple',
        { qcDataList: payload }
      );
      const file = new Blob([report.data], { type: 'octet/stream' });
      yield call(saveAs, file, 'multiple_qc.zip');
      yield put(action.modalSKZipCreateSuccess());
    }
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.message,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.modalSKZipCreateFail());
    yield put(stopProgressBar());
    yield put(clearProgressBar());
  }
}

// export function* modalStocksCheck({ type, payload }) {
//   try {
//     console.debug('modalStocksCheck', type, payload);
//     switch (type) {
//       // разместить на склад
//       case 'MODAL_POST_STOCK_CONSIGNMENT_OPEN':
//         if (!isOne(payload.selectSubmergeItems, 'plantId')) {
//           // eslint-disable-next-line no-throw-literal
//           throw ({ message: formatMessage('textError').differentWarehousesSelected });
//         }
//         break;
//       default:
//         break;
//     }
//   } catch (error) {
//     yield put(
//       modalErrorOpen({
//         message: error.message,
//         techInfo: '',
//         types: 'info',
//         title: formatMessage('textError').warning
//       })
//     );
//   }
// }

// export function* exportModalSagas() {
//   yield all([
//     takeEvery(MODAL_POST_STOCK_OPEN, modalStocksCheck),
//     takeEvery(MODAL_POST_STOCK_CONSIGNMENT_OPEN, modalStocksCheck),
//     takeEvery(MODAL_SHIPMENT_SUBMERGE_OPEN, modalStocksCheck),
//     takeEvery(MODAL_SHIPMENT_REDEEM_CONSIGNMENT_OPEN, modalStocksCheck),
//     takeEvery(MODAL_SHIPMENT_RETURN_OPEN, modalStocksCheck),
//     takeEvery(MODAL_SHIPMENT_CANCEL_REASON_OPEN, modalStocksCheck),
//     takeEvery(MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_OPEN, modalStocksCheck) // не используется
//   ]);
// }
